<template>
  <!-- 升级发布 -->
  <el-dialog
    :title="$t('button.upgradeRelease')"
    width="650px"
    :visible.sync="releaseVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="params"
        ref="form"
        label-width="auto"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item
          :label="$t('pages.equipment.text249')"
          prop="isForce"
          v-if="params.upgradeType == 1"
        >
          <el-radio-group v-model="params.isForce">
            <el-radio :label="1">{{ $t("pages.system.text87") }}</el-radio>
            <el-radio :label="0">{{ $t("pages.system.text88") }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          :label="$t('pages.equipment.text191')"
          prop="startValidTime"
        >
          <el-date-picker
            v-model="params.startValidTime"
            type="datetime"
            :picker-options="pickerOptions1"
            :placeholder="$t('omission.text11')"
            default-time="00:00:00"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('omission.text10')" prop="upgradeIntro">
          <el-input
            type="textarea"
            :placeholder="$t('public.text1')"
            v-model="params.upgradeIntro"
            maxlength="200"
            rows="4"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">{{
        $t("button.confirmRelease")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { resetDate } from "../../../../utils/util/validate";
export default {
  data() {
    return {
      params: {
        isForce: 1, //是否强制
        startValidTime: "", //开始生效时间
        upgradeIntro: "", //升级说明
        belongCustomerId: "", //客户id
        bikeCategoryId: "", //车辆类别id
        bikeTypeId: "", //车辆型号id
        firmwareId: "", //任务对应固件id
        garyUpgradeTaskId: "", //灰度任务id
        taskType: "", //任务类型 灰度或者正式
        upgradeType: "", //升级方式 蓝牙/4g,1蓝牙 2 4g
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      rules: {
        isForce: [
          {
            required: true,
            message: this.$t("pages.equipment.text250"),
            trigger: "blur",
          },
        ],
        startValidTime: [
          {
            required: true,
            message: this.$t("pages.equipment.text251"),
            trigger: "blur",
          },
        ],
        upgradeIntro: [
          {
            required: true,
            message: this.$t("pages.equipment.text252"),
            trigger: "blur",
          },
          {
            max: 200,
            message: this.$t("pages.equipment.text245"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  watch: {
    releaseVisible(newValue) {
      if (newValue) {
        this.params = {
          isForce: null, //是否强制
          startValidTime: "", //开始生效时间
          upgradeIntro: "", //升级说明
          belongCustomerId: this.platformData.id, //客户id
          bikeCategoryId: this.currentUpdata.bikeCategoryId, //车辆类别id
          bikeTypeId: this.currentUpdata.bikeTypeId, //车辆型号id
          firmwareId: this.currentUpdata.firmwareId, //任务对应固件id
          garyUpgradeTaskId: this.currentUpdata.id, //灰度任务id
          taskType: 1, //任务类型 灰度或者正式
          upgradeType: this.currentUpdata.upgradeType, //升级方式 蓝牙/4g,1蓝牙 2 4g
        };
        if (this.currentUpdata.upgradeType == 2) {
          this.params.isForce = 1; //是否强制
        }
      }
    },
  },
  props: ["releaseVisible", "currentUpdata"],
  methods: {
    //关闭
    handleClose() {
      this.$emit("releaseClose");
    },
    //确认发布
    submitForm() {
      this.params.startValidTime = resetDate(this.params.startValidTime); // 服务结束时间
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.request.UpgradeTaskAdd(this.params).then(() => {
            this.$emit("grayScaleTestList");
            this.$message.success(this.$t("pages.equipment.text253"));
            this.handleClose();
          });
        }
      });
    },
  },
};
</script>
